module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AB")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Anchor Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ATR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Anglican Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AUSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Andrews University Seminary Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BAGD")])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("W. Bauer, W. F. Arndt, F. W. Gingrich, and F. W. Danker, "), _c('em', [_vm._v("A Greek-English Lexicon of the NT and Other Early Christian Literature")]), _vm._v(" (Chicago, 1979"), _c('sub', [_vm._v("2")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin for Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BibRev")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bible Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BibSac")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bibliotheca Sacra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BJRL")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the John Rylands Library")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BTB")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Theology Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CJTh")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Canadian Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Calvin Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CurTM")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Currents in Theology and Mission")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DCG")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dictionary of Christ and the Gospels")]), _vm._v(" (Hastings)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DJG")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dictionary of Jesus and the Gospels")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ET")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvTh")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelische Theologie")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Greg")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Gregorianum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HDB")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hastings’ Dictionary of the Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HERE")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Encyclopedia of Religion and Ethics")]), _vm._v(" (Hastings)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HorBT")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Horizons in Biblical Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HUCA")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hebrew Union College Annual")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IB")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpreter’s Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ICC")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("International Critical Commentary")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IDB")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpreter’s Dictionary of the Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ISBE")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("International Standard Bible Encyclopedia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Bible and Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JJS")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Jewish Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NCB")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Century Bible Commentary")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NIBC")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New International Bible Commentary")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NIC")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New International Commentary")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NT")])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(in titles) New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NT")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OT")])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(in titles) Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("PSTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Perkins School of Theology Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RefTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Reformed Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ResQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Restoration Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Rev and Exp")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Review and Expositor")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RGG")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Religion in Geschichte und Gegenwart")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue de Qumran")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RSR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Recherches de science religieuse")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SB")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scripture Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SJTh")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scottish Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("StEv")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Studio Evangelica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("StTh")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Studio Theologica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SWJT")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Southwestern Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TB")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(" (Kittel)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ThSt")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Th Today")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theology Today")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TLZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theologische Literaturzeitung")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theologische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("USQR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Union Seminary Quarterly Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VigChr")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vigiliae Christianae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WBC")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Word Biblical Commentary")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WThJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Westminster Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WW")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Word and World")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZNTW")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZSysTh")])])]), _vm._v(" "), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für Systematische Theologie")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33f091f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbreviations.vue
// module id = 75
// module chunks = 0